// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3eIoU","header":"MergedInvoice_header__2azIQ"};